const initialState = {
  ticketSAVs: null,
  ticketSAVsLoading: false,
  ticketSAVsError: null,
  ticketSAVsReload: true,
  ticketSAV: null,
  ticketSAVLoading: false,
  ticketSAVError: null,
  ticketSAVReload: null,
  savProducts: [],
  savProductsLoading: false,
  savProductsError: null,
  savRevendeurs: [],
  savRevLoading: false,
  savRevendeursError: null,
  filtersLists: {},
  currentComments: [],
  currentCommentsLoading: false,
  currentAdminComments: [],
  currentAdminCommentsLoading: false,
  createCommentLoading: false,
};

const ticketSAVReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case "TICKETS_SAV_LOADING":
      return {
        ...state,
        ticketSAVsLoading: true,
      };
    case "TICKETS_SAV_FETCHED":
      return {
        ...state,
        ticketSAVsLoading: false,
        ticketSAVs: payload,
      };
    case "TICKETS_SAV_ERROR":
      return {
        ...state,
        ticketSAVsLoading: false,
        ticketSAVsError: payload,
      };
    case "TICKETS_SAV_CANCELLED":
      return { ...state, ticketSAVsLoading: false };
    case "TICKETS_SAV_CREATED":
      return {
        ...state,
        ticketSAVsLoading: false,
      };
    case "TICKET_SAV_LOADING":
      return {
        ...state,
        ticketSAVLoading: true,
      };
    case "TICKET_SAV_FETCHED":
      return {
        ...state,
        ticketSAVLoading: false,
        ticketSAV: payload,
      };
    case "TICKET_SAV_ERROR":
      return {
        ...state,
        ticketSAVLoading: false,
        ticketSAVError: payload,
      };
    case "TICKET_SAV_UPDATED":
    case "TICKET_SAV_DELETED":
      return {
        ...state,
        ticketSAVLoading: false,
      };

    case "SAV_PRODUCTS_LOADING":
      return {
        ...state,
        savProductsLoading: true,
      };
    case "SAV_PRODUCTS_FETCHED":
      return {
        ...state,
        savProductsLoading: false,
        savProducts: payload,
      };
    case "SAV_PRODUCTS_ERROR":
      return {
        ...state,
        savProductsLoading: false,
        savProductsError: payload,
      };

    case "SAV_REVENDEURS_LOADING":
      return {
        ...state,
        savRevLoading: true,
      };
    case "SAV_REVENDEURS_FETCHED":
      return {
        ...state,
        savRevLoading: false,
        savRevendeurs: payload,
      };
    case "SAV_REVENDEURS_ERROR":
      return {
        ...state,
        savRevLoading: false,
        savRevendeursError: payload,
      };

    case "TICKETS_SAV_RELOAD":
      return {
        ...state,
        ticketSAVsReload: !state.ticketSAVsReload,
      };
    case "TICKET_SAV_RELOAD":
      return {
        ...state,
        ticketSAVReload: !state.ticketSAVReload,
      };
    case "FILTERS_FETCHED":
      return {
        ...state,
        filtersLists: payload,
      };
    case "CREATE_COMMENTS_SAV_LOADING":
      return { ...state, createCommentLoading: true };

    case "CREATE_COMMENTS_SAV_SUCCESS":
      return {
        ...state,
        createCommentLoading: false,
      };

    case "FETCH_COMMENTS_SAV_LOADING":
      return { ...state, commentsLoading: true };

    case "FETCH_COMMENTS_SAV_SUCCESS":
      return { ...state, currentComments: payload, commentsLoading: false };

    case "CREATE_ADMIN_COMMENTS_SAV_LOADING":
      return { ...state, createCommentLoading: true };

    case "CREATE_ADMIN_COMMENTS_SAV_SUCCESS":
      return {
        ...state,
        createCommentLoading: false,
      };

    case "FETCH_ADMIN_COMMENTS_SAV_LOADING":
      return { ...state, currentAdminCommentsLoading: true };

    case "FETCH_ADMIN_COMMENTS_SAV_SUCCESS":
      return {
        ...state,
        currentAdminComments: payload,
        currentAdminCommentsLoading: false,
      };

    case "UPDATE_SAV_COMMENT_SUCCESS": {
      const updatedComments = state.currentComments.map((comment) => {
        if (+comment?.id === +payload?.id) {
          return payload;
        }
        return comment;
      });
      return {
        ...state,
        currentComments: updatedComments,
        commentsLoading: false,
      };
    }
    case "DELETE_SAV_COMMENT_SUCCESS": {
      const updatedComments = state.currentComments.filter((comment) => {
        return +comment?.id !== +payload;
      });
      return {
        ...state,
        currentComments: updatedComments,
        commentsLoading: false,
      };
    }
    case "UPDATE_ADMIN_SAV_COMMENT_SUCCESS": {
      const updatedComments = state.currentAdminComments.map((comment) => {
        if (+comment?.id === +payload?.id) {
          return payload;
        }
        return comment;
      });
      return {
        ...state,
        currentAdminComments: updatedComments,
        currentAdminCommentsLoading: false,
      };
    }
    case "DELETE_ADMIN_SAV_COMMENT_SUCCESS": {
      const updatedComments = state.currentAdminComments.filter((comment) => {
        return +comment?.id !== +payload;
      });
      return {
        ...state,
        currentAdminComments: updatedComments,
        currentAdminCommentsLoading: false,
      };
    }

    // TICKET
    case "FETCH_UPDATED_TICKET": {
      return {
        ...state,
        ticketSAVs: state.ticketSAVs?.map((ticket) => {
          if (+ticket?.id === +payload?.id) {
            return payload;
          }
          return ticket;
        }),
      };
    }

    // COMMENT
    case "FETCH_ADMIN_COMMENT_SAV_SUCCESS": {
      if (payload.update) {
        return {
          ...state,
          currentAdminComments: state.currentAdminComments.map((comment) => {
            if (+comment?.id === +payload?.data?.id) {
              return payload?.data;
            }
            return comment;
          }),
          currentAdminCommentsLoading: false,
        };
      }
      return {
        ...state,
        currentAdminComments: [payload?.data, ...state.currentAdminComments],
        currentAdminCommentsLoading: false,
      };
    }
    case "FETCH_COMMENT_SAV_SUCCESS": {
      if (payload.update) {
        return {
          ...state,
          currentComments: state.currentComments.map((comment) => {
            if (+comment?.id === +payload?.data?.id) {
              return payload?.data;
            }
            return comment;
          }),
          commentsLoading: false,
        };
      }
      return {
        ...state,
        currentComments: [payload?.data, ...state.currentComments],
        commentsLoading: false,
      };
    }

    case "FETCH_UPDATED_TICKET_NOTIFICATIONS": {
      return {
        ...state,
        ticketSAV: {
          ...state.ticketSAV,
          notifications: payload,
        },
      };
    }

    default:
      return state;
  }
};

export default ticketSAVReducer;
